<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <h4 class="card-title">{{ cvCardTitle }}</h4>
          </template>
          <template v-slot:body>
            <form action="#" v-if="vmProductInviteFormData && Object.keys(vmProductInviteFormData).length > 0">
              <div class="row w-100 ml-0">
                <div class="col-12 col-sm-5 col-md-4 col-lg-4 mb-3" v-if="!productName">
                  <label for="productName">{{ cvProductCode }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                  <ValidationProvider name="Product Name / Code" rules="required|min:1" v-slot="{ errors }">
                    <select id="productCode" v-model="productName" class="form-control" @change="updateProduct(productName)">
                      <option disabled value="">Please Select</option>
                      <option v-for="(products, index) in GideProducts" :value="products" :key="index">
                        {{ products == "spcm" ? "Counseling" : (products == "IEC" ? "GIDEPreneur" : (products == "gideplus" ? "Student Club" : products)) }} [{{ products }}]</option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <ValidationObserver ref="inviteUserForm" class="row w-100 m-0">
                <div class="row w-100 ml-0" v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'">
                  <!-- meritto id -->
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
                    <label>{{ cvStudentMerittoIdLabel }}</label>&nbsp;<label class="primary-color font-size-16" title="Meritto is GIDE.AI's CRM Platform. Use this ID to track the student across GIDE.AI's platform.">
                      <sup><i class="fa fa-info-circle" aria-hidden="true"></i></sup>
                    </label>
                    <input v-model="vmProductInviteFormData.meritto_id" type="text" class="form-control" placeholder="Enter Meritto ID" required />
                  </div><!-- meritto id -->
                </div>

                <div class="row w-100 ml-0">
                  <!-- student email -->
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
                    <label for="validationslot_student_email">{{ cvStudentEmailLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Student Email" rules="required|min:2" v-slot="{ errors }">
                      <input @change="userVerify(vmProductInviteFormData.stu_email, 'stu')" v-if="propStudent && propStudent.student_email" v-model="vmProductInviteFormData.stu_email" readonly type="text" class="form-control" required />
                      <input @change="userVerify(vmProductInviteFormData.stu_email, 'stu')" v-else v-model="vmProductInviteFormData.stu_email" type="text" class="form-control" required />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- student email -->

                  <!-- student class -->
                  <div class="col-12 col-sm-4 col-md-4 col-lg-2 mb-3">
                    <label for="studentClass">{{ cvStudentClass }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Student Class" rules="required|min:1" v-slot="{ errors }">
                      <select id="studentClass" v-model="vmProductInviteFormData.stu_class" class="form-control">
                        <option disabled value="">Please Select Class</option>
                        <option v-for="(classNo, key) in ClassJson" :value="classNo" :key="key">{{ classNo === '13' ? 'Bachelors / Undergraduate' : classNo }}</option>
                      </select>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider><!-- student class -->
                  </div>
                </div>

                <div class="row w-100 ml-0">
                  <!-- student name -->
                  <div class="col-12 col-sm-5 col-md-4 col-lg-4 mb-3">
                    <label for="validationslot_student_name">{{ cvStudentNameLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Student Name" rules="required|min:2" v-slot="{ errors }">
                      <input v-model="vmProductInviteFormData.student_name" type="text" class="form-control" required/>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- student name -->

                  <!-- Student Mobile Country Code -->
                  <div class="col-12 col-sm-4 col-md-3 col-lg-2 mb-3">
                    <label for="validationbill_country">Country Code</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Student Mobile Country Code" rules="required|min:2" v-slot="{ errors }">
                      <select v-model="vmProductInviteFormData.stu_mobile_country_code" class="form-control w-100" id="validation_country">
                        <template class="w-100">
                          <option class="w-100" v-for="(country, index) of cvCountryOptions" :key="index+'1'" :value="`+${country.country_phone_code}`">
                            {{country.country_name}} (+ {{country.country_phone_code}})
                          </option>
                        </template>
                      </select>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- Student Mobile Country Code -->

                  <!-- student Mobile -->
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
                    <label for="validationslot_student_mobile">{{ cvStudentMobileLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Student Mobile Number" rules="required|min:3|max:20" v-slot="{ errors }">
                      <input v-if="propStudent && propStudent.student_mobile" v-model="vmProductInviteFormData.stu_mobile" readonly type="tel" minlength="3" maxlength="20" pattern="[0-9]" class="form-control" required />
                      <input v-else v-model="vmProductInviteFormData.stu_mobile" type="tel" minlength="3" maxlength="20" pattern="[0-9]" class="form-control" required />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- student Mobile -->
                </div>

                <!-- parent Name -->
                <div class="row w-100 ml-0">
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
                    <label for="validationslot_parent_name">{{ cvParentNameLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Parent Name" rules="required|min:2" v-slot="{ errors }">
                      <input v-model="vmProductInviteFormData.parent_name" type="text" class="form-control" required/>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div><!-- parent Name -->

                <div class="row w-100 ml-0">
                  <!-- Parent/other email -->
                  <div class="col-12 col-sm-5 col-md-4 col-lg-4 mb-3">
                    <label for="validationslot_other_email">{{ cvOtherEmailLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Parent/Other Email" rules="required|min:2" v-slot="{ errors }">
                        <input v-if="propStudent && propStudent.other_email" v-model="vmProductInviteFormData.other_email" readonly type="text" class="form-control" required />
                        <input v-else v-model="vmProductInviteFormData.other_email" type="text" class="form-control" required />
                        <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- Parent/other email -->

                  <!-- Parent/Other Mobile Country Code -->
                  <div class="col-12 col-sm-3 col-md-3 col-lg-2 mb-3">
                    <label for="validationbill_country">Country Code</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Parent/Other Mobile Country Code" rules="required|min:2" v-slot="{ errors }">
                      <select v-model="vmProductInviteFormData.other_mobile_country_code" class="form-control w-100" id="validation_country">
                        <template class="w-100">
                          <option class="w-100" v-for="(country, index) of cvCountryOptions" :key="index+'1'" :value="`+${country.country_phone_code}`">
                            {{country.country_name}} (+ {{country.country_phone_code}})
                          </option>
                        </template>
                      </select>
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- Parent/Other Mobile Country Code -->

                  <!-- Parent/other Mobile -->
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
                    <label for="validationslot_other_email">{{ cvOtherMobileLabel }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Parent/Other Mobile" rules="required|min:2" v-slot="{ errors }">
                      <input v-if="propStudent && propStudent.other_mobile" v-model="vmProductInviteFormData.other_mobile" readonly type="text" class="form-control" required />
                      <input v-else v-model="vmProductInviteFormData.other_mobile" type="text" class="form-control" required />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- Parent/other Mobile -->
                </div>

                <!-- IS SPCM -->
                <div class="row w-100 ml-0" v-if="productName == 'spcm'">
                  <!-- SPCM Category -->
                  <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-3">
                    <label for="spcmcategory">{{ cvSpcmCategoryLabel }}</label>&nbsp;
                    <select id="spcmcategory" v-model="vmProductInviteFormData.spcm_category" class="form-control">
                      <option disabled value="">Select Counseling Type</option>
                      <option v-for="(category, key) in SpcmCategory" :value="category" :key="key">{{ category }}</option>
                    </select>
                  </div><!-- SPCM Category -->
                </div>

                <div class="row w-100 ml-0" v-if="productName == 'spcm'">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mb-3">
                    <label for="">{{ cvSelecteCountryStrategy }}</label>
                    <b-form-checkbox-group
                      id="checkbox-group-1"
                      v-model="selected_ms_country_strategy"
                      :options="country_strategy_list"
                      name="flavour-1"
                      class="mt-2"
                      ></b-form-checkbox-group>
                  </div>
                </div><!-- IS SPCM -->

                <div class="row w-100 ml-0">
                  <!-- Subscription Plan Dropdown -->
                  <div class="col-12 col-sm-10 col-md-10 col-lg-10 mb-3" v-if="(userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118')">
                    <label for="validationslot_subscription_plan">{{ cvSubscriptionPlan }}</label>&nbsp;<label class="primary-color font-size-16">*</label>
                    <ValidationProvider name="Subscription Plan" rules="required|min:2" v-slot="{ errors }">
                      <!-- Removed :reduce="plan => plan.id", since we need the entire object -->
                      <multiselect
                        v-model="vmProductInviteFormData.subs_plan_id"
                        :options="cleanedPlanList"
                        label="label"
                        track-by="id"
                        placeholder="Select Payment Plan"
                      />
                      <span class="text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div><!-- Subscription Plan Dropdown -->

                  <div class="row w-100 ml-0">
                    <div class="col-12 col-sm-6 col-md-6 col-lg-6 mb-3">
                      <button type="button" class="btn btn-primary" :disabled="disableGetCode" @click="generateAffLink()">{{ cvGetCodeBtn }}</button>&nbsp;&nbsp;:&nbsp;&nbsp;
                        <span class="mt-2 mr-4" v-if="busy" v-infinite-scroll="generateAffLink" infinite-scroll-disabled="busy" infinite-scroll-distance="10" :key="busy">
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </span>
                      <span v-if="vmProductInviteFormData.aff_code" style="vertical-align: middle; color: #e5252c; font-size: 18px;">
                        {{vmProductInviteFormData.aff_code}}
                      </span>
                    </div>
                  </div>
                </div>
              </ValidationObserver>
            </form>

            <div>
              <div v-if="(noDiscountCode)">
                <span class="ml-1">No Codes Available or Plan Expired.</span>&nbsp;
                <b-btn variant="primary mr-2 mb-2" :id="buyNow ? 'blinking-button' : ''" @click="navigateTo('/subscription_plans')">Buy More Codes</b-btn>
              </div>
              <div v-else>
                <button v-if="vmProductInviteFormData.attach_aff_code" type="button" class="btn btn-primary ml-1 mt-1" @click="inviteUser()" :disabled="!disableGetCode && vmProductInviteFormData.attach_aff_code">{{ cvInviteBtn }}</button>

                <!-- <button v-if="vmProductInviteFormData.attach_aff_code && userData.user_role == 'USERROLE11111'" type="button" class="btn btn-primary ml-1 mt-1" @click="inviteUser(true)" :disabled="!disableGetCode && vmProductInviteFormData.attach_aff_code">{{ cvInviteBtnV1 }}<sup>Beta</sup></button> -->
                <span v-else>
                  <button type="button" class="btn btn-primary ml-1 mt-1" :disabled="!noDiscountCode" @click="inviteUser()">{{ cvInviteBtn }}</button>
                  <!-- <button v-if="userData.user_role == 'USERROLE11111'" type="button" class="btn btn-primary ml-1 mt-1" :disabled="!noDiscountCode" @click="inviteUser(true)">{{ cvInviteBtnV1 }}<sup>Beta</sup></button> -->
                </span>
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast
      v-model="showToast"
      name="Toast"
      :variant="toastVariant"
      :title="toastTitle"
    >
      <div v-html="toastMsg"></div>
    </b-toast>

    <!-- PreCounselling is dynamically executed using dynamic ref instance parameters -->
     <div v-if="showCounsellingQuizModal">
      <PreCounsellingv1 :propQuestionObj="salesQuestionObj" @emitClosePreCounsellingQuizModal="closePreCounsellingQuizModal"/>
    </div>

  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import { socialvue } from "../config/pluginInit"
import { ValidationProvider } from "vee-validate"
import { Affiliates } from "../FackApi/api/Affiliate"
import { Spcms } from "../FackApi/api/Spcm"
import ApiResponse from "../Utils/apiResponse"
import { GPathSessions } from "../FackApi/api/GPathSession"
import { TprepSessions } from "../FackApi/api/TprepSession"
import { SubscriptionPlans } from "../FackApi/api/Subscription/subscriptionPlan"
import GideProducts from "../FackApi/json/GideProducts.json"
import TestSeriesConfigJson from "../FackApi/json/TestSeries.json"
import SpcmCategory from "../FackApi/json/SpcmCategory.json"
import ClassJson from "../FackApi/json/Class.json"
import { spcmMilestones } from "../FackApi/api/Spcmmilestones"
import { Countries } from "../FackApi/api/country.js"
import userPermission from "../Utils/user_permission.js"
import Multiselect from "vue-multiselect"
import encryptAndDecrypt from "../Utils/encryptAnddecrypt.js"
import { User } from "../FackApi/api/user.js"
import { UserParent } from "../FackApi/api/userParent.js"
import { inviteUser } from "../FackApi/api/inviteUser.js"
import PreCounsellingv1 from "../views/Gide/Quiz/PreCounsellingv1.vue"

export default {
  name: "InviteStudent",
  components: {
    ValidationProvider,
    Multiselect,
    PreCounsellingv1
  },
  data () {
    return {
      apiName: "invite",
      TestSeriesConfigJson: TestSeriesConfigJson,
      SpcmCategory: SpcmCategory,
      ClassJson: ClassJson,
      cvCardTitle: "Invite Student",
      cvGetCodeBtn: `Get Discount / Payment Code`,
      cvInviteBtn: "Invite",
      cvInviteBtnV1: "InviteV1",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Invite User",
      vmProductInviteFormData: Object.assign({}, this.initFormData()),
      cvProductCode: "Product Name / Code",
      cvStudentEmailLabel: "Student Email",
      cvStudentMerittoIdLabel: "Meritto Id",
      cvStudentMobileLabel: "Student Mobile",
      cvOtherEmailLabel: "Parent/Other Email",
      cvOtherMobileLabel: "Parent/Other Mobile",
      cvStudentClass: "Student Class",
      cvStudentNameLabel: "Student Name",
      cvParentNameLabel: "Parent Name",
      affiliateCodeObj: null,
      disableGetCode: false,
      cvSubscriptionPlan: "Payment Plans",
      cvSpcmCategoryLabel: "Counseling Category",
      cvSelecteCountryStrategy: "Country Strategy",
      planIdList: [],
      country_strategy_list: [],
      selected_ms_country_strategy: [],
      GideProducts: GideProducts,
      cvCountryOptions: [],
      productName: null,
      noDiscountCode: false,
      sendEmailInvite: false,
      buyNow: false,
      busy: false,
      cleanedPlanList: [],
      existingStudentId: null,
      showCounsellingQuizModal: false,
      salesQuestionObj: {
        "app_id": null,
        "qbk_category": null,
        "user_id": null // If the user/student already exists then set it else after invite a new user id get created, then use it
      }
    }
  },
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propCounsellor: {
      type: Object,
      default: function () {
        return {
          user_name: ""
        }
      }
    },
    propStudent: {
      type: Object,
      default: null
    },
    propProductCode: {
      type: String,
      default: null
    },
    propProductName: {
      type: String,
      default: null
    },
    propsalesQuestionObj: {
      type: Object,
      default: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    gidePlusData () {
      return this.$store.getters["Paygw/myPlanState"]
    }
  },
  beforeMount () {
    // Auth Access for Current User Role. Also allow to open this component in Modal Box and not in a URL as URL is only for GIDE Team
    if (this.userData.user_role != "USERROLE11111" && this.userData.user_role != "USERROLE11118") {
      if (!userPermission(this, this.userData, this.apiName)) {
        this.$router.back()
      }
    }
  },
  mounted () {
    socialvue.index()

    this.productName = this.$route.params.productCode ? this.$route.params.productCode : this.propProductCode
    this.productName = this.productName ? this.productName.toLowerCase() : null

    // We are using special plans to track revenue from the usage of referal codes by GIDEPreneur under the revenue src B2G
    if (this.userData.user_role == "USERROLE11116") {
      switch (this.productName) {
        case "gpaths":
          this.vmProductInviteFormData.subs_plan_id = { id: "GPATHS-GIDEPRENEUR-B2G" }
          break
        default:
          console.error("Invalid product code")
      }
    }

    // student data is passed as a prop in spcm fireflies list
    if (this.propStudent) {
      this.vmProductInviteFormData.stu_email = this.propStudent.student_email
    }

    this.updateProduct(this.productName)

    this.countryDistinctList()
    this.getDateDifferenceInDays()

    this.salesQuestionObj = {
      user_id: this.userData.user_id,
      app_id: this.propsalesQuestionObj?.app_id ? this.propsalesQuestionObj.app_id : null,
      qbk_category: this.propsalesQuestionObj?.qbk_category ? this.propsalesQuestionObj.qbk_category : "sales" // Get Sales Specific Questions
    }
  },
  methods: {
    /**
     * customPlanLabel
     */
    customPlanLabel (option) {
      return `${option.subs_plan_name} - ${option.subs_plan_price}`
    },
    /**
     * navigate To
     */
    navigateTo (url) {
      this.$router.push(url)
    },
    /**
     * updateProduct
     */
    updateProduct (productName) {
      this.productName = productName

      if (this.productName == GideProducts.COUNSELLING) {
        this.spcm_CountryStrategyList()
      }

      this.getPlanNames(this.productName)
    },
    /* eslint-enable */
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmProductInviteFormData) {
          if (!this.vmProductInviteFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error(
          "Exception occurred at validate() and Exception:",
          err.message
        )
        return null
      }
    },
    /**
     * countryDistinctList
     */
    async countryDistinctList () {
      try {
        let matchWithQuery = "distinct country"
        let countryDistinctListResp = await Countries.countryList(this, matchWithQuery)
        if (countryDistinctListResp && !countryDistinctListResp.resp_status) {
          return false
        }
        this.cvCountryOptions = countryDistinctListResp.resp_data.data
      }
      catch (err) {
        console.error("Exception occurred at countryDistinctList() and Exception:", err.message)
      }
    },
    /**
     * generateAffLink
     */
    async generateAffLink () {
      if (this.vmProductInviteFormData.stu_email == "") {
        this.toastTitle = "Invite User"
        this.toastMsg = "User Email Id is Missing"
        this.toastVariant = "danger"
        this.showToast = true
        return
      }
      this.busy = true

      // Since the button to generate code is clicked set the affiliated flag to true
      this.vmProductInviteFormData.attach_aff_code = true
      /**
       As of now the only product that is affiliated, is GPATHS so hardcoding the product_name to GPATHS, because the module_name in affiliate table needs to be
       the product_name(e.g. GPATHS, SPCMCOUNCEL etc).
       todo:- We have to create a propper system to get other products on GIDE, affiliated
       */
      const getCodeObj = {
        aff_entity_id: this.userData.org_id,
        user_email: this.vmProductInviteFormData.stu_email,
        product_name: this.productName
      }
      let affiliateResp = await Affiliates.AffiliateGetCode(this, getCodeObj)

      if (!affiliateResp.resp_status) {
        this.toastTitle = "Invite User"
        this.toastMsg = affiliateResp.resp_msg
        this.toastVariant = "danger"
        this.showToast = true
        this.busy = false
        return
      }

      this.busy = false
      this.affiliateCodeObj = affiliateResp.resp_data.data
      this.vmProductInviteFormData.aff_code = this.affiliateCodeObj.aff_code
      this.disableGetCode = true
    },
    /**
     * invite User
     */
    async inviteUser (useInviteV1 = false) {
      try {
        let valid = await this.$refs.inviteUserForm.validate()
        if (!valid) {
          return
        }
        if (!this.noDiscountCode && !this.vmProductInviteFormData.aff_code) {
          this.toastMsg = "Missing Discount/Payment Code"
          this.toastVariant = "danger"
          this.showToast = true
          return
        }
        else {
          this.vmProductInviteFormData.no_aff_code = false
        }

        if (this.affiliateCodeObj) {
          this.vmProductInviteFormData.aff_id = this.affiliateCodeObj.aff_id
          this.vmProductInviteFormData.aff_entity_id = this.affiliateCodeObj.aff_entity_id
        }

        this.module_name = this.productName
        this.vmProductInviteFormData.product_name = this.productName
        this.vmProductInviteFormData.module_name = this.productName

        // set the subs_plan_id and the pdt_id
        let selectedSubsPlan = this.vmProductInviteFormData.subs_plan_id
        this.vmProductInviteFormData.subs_plan_id = selectedSubsPlan.id
        if (selectedSubsPlan.pdt_id) {
          this.vmProductInviteFormData.pdt_id = selectedSubsPlan.pdt_id
        }

        let response = null

        if (this.propCounsellor) {
          this.vmProductInviteFormData.counsellor_id = this.propCounsellor.user_id
        }

        this.vmProductInviteFormData.source = this.userData.ref_code // Used to identify the sales person

        if (useInviteV1 == false) {
          switch (this.module_name) {
            case this.GideProducts.COUNSELLING:
              this.vmProductInviteFormData.ms_country_strategy = this.selected_ms_country_strategy.join(",")
              if (!this.vmProductInviteFormData.stu_class || !this.vmProductInviteFormData.spcm_category || !this.vmProductInviteFormData.ms_country_strategy) {
                this.toastMsg = "Student's class, counseling category and strategy are mandatory"
                this.toastVariant = "danger"
                this.showToast = true
                return
              }
              response = await Spcms.spcmStudentPublicReg(this, this.vmProductInviteFormData)
              break

            case this.GideProducts.GPATHS:
              response = await GPathSessions.gpath_invite(this, this.vmProductInviteFormData)
              break

            case this.GideProducts.TESTSERIES:
              response = await TprepSessions.tprep_invite(this, this.vmProductInviteFormData)
              break

            default:
              console.error(`${this.module_name} is not available to invite`)
              this.toastMsg = `Cannot add a student in this module - ${this.module_name}`
              this.toastVariant = "danger"
              this.showToast = true
              return
          }
        }
        else {
          switch (this.module_name) {
            case this.GideProducts.COUNSELLING:
              this.vmProductInviteFormData.ms_country_strategy = this.selected_ms_country_strategy.join(",")
              if (!this.vmProductInviteFormData.stu_class || !this.vmProductInviteFormData.spcm_category || !this.vmProductInviteFormData.ms_country_strategy) {
                this.toastMsg = "Student's class, counseling category and strategy are mandatory"
                this.toastVariant = "danger"
                this.showToast = true
                return
              }
              this.vmProductInviteFormData.pdt_code = this.productName
              response = await inviteUser.inviteUser(this, this.vmProductInviteFormData)
              break

            case this.GideProducts.GPATHS:
              this.vmProductInviteFormData.pdt_code = this.productName
              response = await inviteUser.inviteUser(this, this.vmProductInviteFormData)
              break

            case this.GideProducts.TESTSERIES:
              this.vmProductInviteFormData.pdt_code = this.productName
              response = await inviteUser.inviteUser(this, this.vmProductInviteFormData)
              break

            default:
              console.error(`${this.module_name} is not available to invite`)
              this.toastMsg = `Cannot add a student in this module - ${this.module_name}`
              this.toastVariant = "danger"
              this.showToast = true
              return
          }
        }

        this.toastTitle = "Invite User"
        if (response.resp_code == "ERR_UNUSED_CODE") {
          this.toastVariant = "warning"
        }
        else if (response.resp_code == "ERR_VALIDATION") {
          ApiResponse.responseMessageDisplay(this, response)
        }
        else {
          this.toastVariant = response.resp_status ? "success" : "danger"
        }

        this.toastMsg = response.resp_msg
        this.showToast = true

        if (response.resp_status) {
          this.disableGetCode = false

          // console.log(this.existingStudentId, "@@@@@@", this.salesQuestionObj, "XXXX Invite Response: ", response)
          this.salesQuestionObj.user_id = response.resp_data?.user?.user_id || this.existingStudentId

          if (this.$route.query.category == "sales") {
            // Open because Sales team wants to ask pre-counselling questions to the student after invite
            this.showCounsellingQuizModal = true
          }

          this.vmProductInviteFormData.aff_code = null
        }
      }
      catch (err) {
        console.error("Exception in Invite: ", err)
      }
    },
    /**
     * close PreCounselling Quiz Modal
     */
    closePreCounsellingQuizModal () {
      this.showCounsellingQuizModal = false
    },
    /**
     * spcm_CountryStrategyList
     */
    async spcm_CountryStrategyList () {
      try {
        let spcmCountryStrategyListResp = await spcmMilestones.spcm_CountryStrategyList(this, this.whereFilter)
        if (spcmCountryStrategyListResp.resp_status) {
          this.country_strategy_list = spcmCountryStrategyListResp.resp_data.data.map(e => e.ms_country_strategy)
        }
        else {
          this.showLoadMoreBtn = false
          this.toastMsg = spcmCountryStrategyListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at spcm_CountryStrategyObjList() and Exception:", err)
      }
    },
    /**
     * initFormData
     */
    initFormData () {
      return {
        student_name: "",
        stu_first_name: "",
        stu_last_name: "",
        stu_email: "",
        meritto_id: "",
        user_type: "Student",
        product_name: this.productName,
        aff_code: ""
      }
    },
    /**
     * getPlanNames
     */
    async getPlanNames (productName) {
      try {
        const subsPlanListResp = await SubscriptionPlans.subscriptionPlanList(this, { subs_plan_name: productName })
        if (subsPlanListResp.resp_status) {
          this.planIdList = subsPlanListResp.resp_data.data
          this.cleanedPlanList = this.planIdList.map(plan => ({
            id: plan.subs_plan_id,
            pdt_id: plan.pdt_id,
            label: `${plan.subs_plan_name} (${plan.subs_plan_id})`
          }))
        }
      }
      catch (err) {
        console.error("Error in getPlanNames ", err)
      }
    },
    /**
     * getDateDifferenceInDays
     */
    getDateDifferenceInDays () {
      const currentDate = new Date()
      const subsEndOnDate = new Date(this.gidePlusData.subs_end_on_date)

      const diffTime = subsEndOnDate - currentDate

      // Convert to days (ms → s → min → hr → day)
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))

      if (diffDays <= 5) {
        this.noDiscountCode = true
        this.disableGetCode = true
        this.buyNow = true
      }
    },
    /**
     * verify Student Exists on Gide Platform or not
     */
    async userVerify (stuEmail) {
      let response = await User.userVerify(this, { "user_email": stuEmail })

      if (!response.resp_status) return

      let userId = response.resp_data.user_id
      this.existingStudentId = userId

      // GET LAST UPDATED PARENT DATA
      let userParentListResp = await UserParent.user_parentList(this, userId)
      if (userParentListResp.resp_status) {
        const list = userParentListResp.resp_data.data
        if (list.length > 0) {
          this.ParentData = list.reduce((latest, record) => {
            return new Date(record.modified_on) > new Date(latest.modified_on) ? record : latest
          })
          this.vmProductInviteFormData.parent_name = this.ParentData.parent_name ?? "Parent"
          this.vmProductInviteFormData.other_email = this.ParentData.parent_email ?? "parent@gide.ai"
          this.vmProductInviteFormData.other_mobile_country_code = this.ParentData.parent_mobile_country_code ?? "+91"
          this.vmProductInviteFormData.other_mobile = this.ParentData.parent_mobile ?? "9999999999"
        }
      }

      // GET COMPLETE USER DATA
      let userCompleteDetails = await User.userViewPublic(this, userId, userId)
      if (!userCompleteDetails.resp_status) {
        this.toastVariant = "danger"
        this.toastMsg = "Cannot get info about the registered user"
        this.showToast = true
        return
      }

      userCompleteDetails = userCompleteDetails.resp_data.data
      // Update all student fields
      this.vmProductInviteFormData.student_name = userCompleteDetails.user_name
      this.vmProductInviteFormData.stu_class = userCompleteDetails.class_name
      this.vmProductInviteFormData.stu_mobile_country_code = userCompleteDetails.user_mobile_country_code
      this.vmProductInviteFormData.stu_mobile = (await encryptAndDecrypt.decryptPIIData(userId, { user_mobile: userCompleteDetails.user_mobile })).user_mobile

      this.$nextTick(() => {
        this.$refs.inviteUserForm.validate().then(valid => {
          if (valid) {
            this.inviteUser()
          }
        })
      })
    }
  }
}
</script>
<style>
@media (max-width: 991px) {
  label{
    font-size:13px;
  }
}
</style>
